import { getLabel } from '../../InitData';
import { prematchPrefix } from '../../Container';
import ContentWrapper from '../../common/ContentWrapper';
import TopCompetitions from '../../common/TopCompetitions';
import LeftSidebar from '../../common/left-sidebar/LeftSidebar';
import SidebarLink from '../../common/left-sidebar/SidebarLink';
import CollapseMenu from '../../common/menu/CollapseMenu';
import RightSidebar from '../../common/right-sidebar/RightSidebar';
import SearchResults from '../../common/search/SearchResults';
import Outlet from '../../router/Outlet';
import RouteDataProvider from '../../router/RouteDataProvider';
import { useParams } from '../../router/Router';
import Menu from './menu/Menu';
import { getAllLink } from '../PrematchWrapper';
import FilterProvider from './FilterProvider';
import TournamentsByDateData from './TournamentsByDateData';
import TournamentsByDateFetcher from './TournamentsByDateFetcher';
import LastMinute from '../../common/right-sidebar/LastMinute';
import BottomBanners from '../../common/right-sidebar/BottomBanners';
import SportFetcher from './SportFetcher';

export default function TournamentsByDate() {
    const p = useParams();

    return (
        <TournamentsByDateData renderItem={(baseData) =>
            <TournamentsByDateFetcher key={p.hour} {...baseData} renderItem={(landingData) =>
                <SportFetcher baseData={baseData} data={landingData} renderItem={(tournamentsData) => 
                    <div className="c_8">
                        <RouteDataProvider data={{date: baseData.date, tournamentsData}}>
                            <LeftSidebar>
                                <SearchResults />
                                <TopCompetitions />
                                <CollapseMenu title={getLabel('general.sports')} info={tournamentsData.events.length}>
                                    <SidebarLink href={`${prematchPrefix}/favorites`} icon={'Favs_default.svg'} text={getLabel('general.favorites')} info={null} />
                                    <SidebarLink href={getAllLink()} icon={'icon_allsports.svg'} text={getLabel('general.all_sports')} info={null} />
                                    <SidebarLink href={`${prematchPrefix}/daily-flash-odds`} icon={'daily_flash_odds.svg'} text={getLabel('daily_flash_odds')} />
                                    <FilterProvider filter={baseData.date}>
                                        <Menu sports={tournamentsData.sport} />
                                    </FilterProvider>
                                </CollapseMenu>
                            </LeftSidebar>
                            {/* <ErrorBoundary fallback={<ErrorMessageWithLink />}>
                            </ErrorBoundary> */}
                            <ContentWrapper columns="1">
                                <Outlet />
                                <div></div>
                            </ContentWrapper>
                        </RouteDataProvider>
                        <RightSidebar>
                            <LastMinute />
                            <BottomBanners />
                        </RightSidebar>
                    </div>
                } />
            } />
        } />
    );
}
